export const SET_FICHIERS_IMPORTATION = 'SET_FICHIERS_IMPORTATION'
